export const ADDITIONAL_DETAILS_BOLD_TEXT = 'This is a lesson preview.'
export const ADDITIONAL_DETAILS_ACTION_TEXT =
  'To teach this lesson to students, <0>go to your classes</0>.'
export const ADDITIONAL_DETAILS_TIER2_ACTION_TEXT =
  'To teach this lesson to students, <0>go to your small groups</0>.'
